import $ from 'jquery';
import myEase from './easing';
import createChart from './pieChart';
import initTabs from './tabs';

$(function(){    
    var charts = $('.chart');

    myEase({
        startValue: 0,
        endValue: charts.length,
        durationMs: 2000,
        timeout: 2000,
        discreteSteps: true
    },
    function(value){
        if(value < charts.length){
            createChart($(charts[value]));
            $(charts[value]).addClass("initialized");
        }
     });

     createChart($('.subchart'));
     $('.subchart').addClass("initialized");
    // ************************ tabs *********************************************
     initTabs($('.tabs'));
    /*
    $(".tab-navigation").on("click",">li",function(){
        let li = $(this).closest("li");
        if(li.hasClass('active')){
            li.removeClass('active');
            $(".navigation-body").removeClass("active");

            $(`.navigation-body`).css({'max-height':`0px`});
        }
        else{
            var contentToSelect = li.data("select");
            var tabToOpen = $(this).closest("ul").data("open");
            $(".navigation-body").removeClass("active");
            $(".navigation-body .tab").removeClass("active");
            $(`#${contentToSelect}`).addClass("active");$(".navigation-body .tab").removeClass("active");
            $(`#${contentToSelect}`).addClass("active");
    
            let height = $(`#${tabToOpen}`)[0].scrollHeight;
            $(`#${tabToOpen}`).addClass("active");
            $(`#${tabToOpen}`).css({'max-height':`${height}px`});

            $(this).closest("ul").find('li').removeClass('active');
            li.addClass('active');
        }

    });
    //*/
    //************************ end tabs ******************************************

    //*************************storyline *****************************************
    var dataObject = {
        "timeline":
        {
            "headline":"The Main Timeline Headline Goes here",
            "type":"default",
            "text":"<p>Intro body text goes here, some HTML is ok</p>",
            "asset": {
                "media":"http://yourdomain_or_socialmedialink_goes_here.jpg",
                "credit":"Credit Name Goes Here",
                "caption":"Caption text goes here"
            },
            "date": [
                {
                    "startDate":"2011,12,10,07,02,10",
                    "endDate":"2011,12,11,08,11",
                    "headline":"Headline Goes Here",
                    "text":"<p>Body text goes here, some HTML is OK</p>",
                    "tag":"This is Optional",
                    "classname":"optionaluniqueclassnamecanbeaddedhere",
                    "asset": {
                        "media":"http://twitter.com/ArjunaSoriano/status/164181156147900416",
                        "thumbnail":"optional-32x32px.jpg",
                        "credit":"Credit Name Goes Here",
                        "caption":"Caption text goes here"
                    }
                }
            ],
            "era": [
                {
                    "startDate":"2011,12,10",
                    "endDate":"2011,12,11",
                    "headline":"Headline Goes Here",
                    "text":"<p>Body text goes here, some HTML is OK</p>",
                    "tag":"This is Optional"
                }
                
            ]
        }
    };

    if($("#my-timeline").length > 0){
        createStoryJS({
            type:		'timeline',
            width:		'800',
            height:		'600',
            source:		dataObject,
            embed_id:	'my-timeline'
        });
    }
    //*************************end storyline *************************************

    setTimeout(function(){
        $(".bar .bar-line").addClass("active");
    },3000);
});